<template>
    <div class="captcha-block">
        <div class="captcha-wrapper">
            <div id="turnstile-box">
                <!--        <Loader v-if="!isCaptchaLoaded" />-->
            </div>
            <div class="hide-captcha-btn" @click="$emit('hideCaptcha')">
                <img src="../../assets/images/closeCaptcha.svg" alt="close">
                <img class="captcha-btn-arrow" src="../../assets/images/right-arrow.svg" alt="Come back">
                <span>Вернуться назад</span>
            </div>
        </div>
    </div>
</template>

<script>
import './captcha.scss'

// import Loader from '@/components/Loader/Loader'

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback'
const SITE_KEY = '0x4AAAAAAACjaqBmnHMMdASH'

export default {
    name: 'Captcha',
    components: {
        // Loader
    },
    data () {
        return {
            isCaptchaLoaded: false
        }
    },
    mounted () {
        if (window.turnstile === null || !window.turnstile) {
            this.loadCaptchaScript()
        } else {
            this.renderCaptcha()
        }

        window.onloadTurnstileCallback = () => {
            this.renderCaptcha()
        }
    },
    methods: {
        renderCaptcha () {
            if (!window.turnstile) {
                return
            }

            window.turnstile.render('#turnstile-box', {
                sitekey: SITE_KEY,
                callback: (token) => {
                    this.$emit('onVerify', token)
                }
            })

            setTimeout(() => {
                this.isCaptchaLoaded = true
            }, 50)
        },
        loadCaptchaScript () {
            const script = document.createElement('script')
            script.src = SCRIPT_SRC
            script.async = true
            script.defer = true
            document.head.appendChild(script)
        }
    }
}
</script>
